import React from 'react';
import RootComponent from './Components/RootComponent';

function App() {
  return (
    <RootComponent />
  );
}

export default App;
